import axios from "axios";
import { DataResponse, PaginatedResponse } from "../models/common/responseObjects";
import { ApnPdeStockResult } from "models/dbModels/apnPdes/ApnPdeStockResult";
import { ApnPdeSearchFilterQuery } from "models/filters/apnPde/ApnPdeSearchFilterQuery";

export class ApnPdeApi {
    static Search = async (query: ApnPdeSearchFilterQuery) => axios.post<DataResponse<ApnPdeStockResult[]>>(`api/v1/ApnPde/SearchApnsAndPdes`, query);
}